import React, { FC } from 'react'
import QRCode from "react-qr-code"
import { ParticipantAdminDto } from '../../types/contracts'

interface QRCodeModalProps {
  isOpen: boolean;
  participant: ParticipantAdminDto|null;
  onDownload: () => void;
  onClose: () => void;
  qrCodeRef: React.RefObject<HTMLDivElement>;
}

const QRCodeModal: FC<QRCodeModalProps> = ({ isOpen, participant, onDownload, onClose, qrCodeRef }) => {
  if (!isOpen || !participant) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded shadow-lg relative" ref={qrCodeRef}>
        <h2 className="text-lg font-bold mb-4">QR Code</h2>
        <QRCode value={participant.code} size={256} />
        <div className="flex justify-end mt-4">
          <button
            className="mr-2 px-4 py-2 bg-blue-500 text-white rounded"
            onClick={onDownload}
          >
            Stáhnout QR Kód
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded"
            onClick={onClose}
          >
            Zavřít
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;